export default __webpack_public_path__ + "static/media/Logo.bb63b4cc.png";